import { Checkbox, ListItemText, Menu, MenuItem, type SelectChangeEvent } from "@mui/material";
import { useRef, useState, type ReactNode } from "react";
import CheckIcon from "@mui/icons-material/Check";
import { Chip } from "~/common/m3/Chip/Chip";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export type OptionType = {
  key: string;
  label: string;
};

type MultiSelectFilterProps = {
  options: OptionType[];
  label: string;
  selectedValues: string[];
  onChange: (event: SelectChangeEvent<string[]>, child: ReactNode) => void;
};

export default function MediaFilter(props: MultiSelectFilterProps) {
  const { label, selectedValues, onChange, options } = props;
  const [open, setOpen] = useState(false);
  const chipRef = useRef<HTMLDivElement | null>(null);

  const hasSelected = selectedValues.length > 0;
  const handleClick = (key: string) => {
    let newSelected: string[];
    if (selectedValues.includes(key)) {
      newSelected = selectedValues.filter((k) => k !== key);
    } else {
      newSelected = [...selectedValues, key];
    }

    // Since onChange expects (event: SelectChangeEvent<string[]>, child: ReactNode)
    const fakeEvent = {
      target: { value: newSelected },
    } as SelectChangeEvent<string[]>;

    onChange(fakeEvent, null);
  };

  const toggleMenu = () => {
    setOpen((prev) => !prev);
  };

  const selectedCount = selectedValues.length > 0 ? ` (${selectedValues.length})` : "";
  const chipLabel = label + selectedCount;

  return (
    <>
      <Chip
        variant="filter"
        label={chipLabel}
        deleteIcon={<ArrowDropDownIcon sx={{ transform: open ? "rotate(180deg)" : "" }} />}
        onDelete={toggleMenu}
        onClick={toggleMenu}
        ref={chipRef}
        selected={hasSelected}
        icon={hasSelected ? <CheckIcon /> : undefined}
      />
      <Menu
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={chipRef.current}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        sx={{
          maxHeight: 56 * 6, // 56 - menu item height
        }}
      >
        {options.map(({ label, key }) => (
          <MenuItem
            key={key}
            onClick={(e) => {
              console.log(e);
              handleClick(key);
            }}
            selected={selectedValues.includes(key)}
          >
            <Checkbox checked={selectedValues.includes(key)} edge="start" />
            <ListItemText primary={label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
